import React from 'react';
import { LeadStatus } from '../../types';
import { useI18n } from '../../context/I18nContext';
import { LEAD_STATUS_I18N_KEYS } from '../../utils/statusUtils';
import Badge from '../ui/Badge';

/** Badge variant par statut lead (aligné avec leadStatusColors). */
export const LEAD_STATUS_BADGE_VARIANT: Record<
  LeadStatus,
  React.ComponentProps<typeof Badge>['variant']
> = {
  to_contact: 'blue-pastel',
  pending: 'yellow-pastel',
  rejected: 'red-dark-pastel',
  abandoned: 'red-light-pastel',
  negotiation: 'orange-pastel',
  in_production: 'violet-pastel',
  completed: 'green-dark-pastel',
};

interface LeadStatusBadgeProps {
  status: LeadStatus | string;
  size?: 'sm' | 'md';
  className?: string;
}

const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({
  status,
  size = 'sm',
  className = 'max-w-full truncate',
}) => {
  const { t } = useI18n();
  const key = status as LeadStatus;
  const variant = LEAD_STATUS_BADGE_VARIANT[key] || 'default';
  const label = t(LEAD_STATUS_I18N_KEYS[key] || 'status.unknown');

  return (
    <Badge variant={variant} size={size} className={className}>
      {label}
    </Badge>
  );
};

export default LeadStatusBadge;
